



















import Vue from 'vue';
import commonClient from '../apis';

export default Vue.extend({
  data() {
    return {
      show: false,
    };
  },
  methods: {
    getShowStatus() {
    	commonClient.isCrmTipConfirmed({
        scene: 'ebook_scrm',
      }).success((r: boolean) => {
      	if (r) {
      		this.show = false;
      	} else {
      		this.show = true;
      	}
      });
    },
    dismiss() {
      commonClient.confirmCrmTip({scene: 'ebook_scrm'});
      this.show = false;
    },
  },
  mounted() {
    this.getShowStatus();
  },
});
